import { render, staticRenderFns } from "./LotViewBidding.vue?vue&type=template&id=8071f38a&"
import script from "./LotViewBidding.vue?vue&type=script&lang=js&"
export * from "./LotViewBidding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports